import { reactive } from 'vue';

export const languageStore = reactive({
  currentLanguage: 'en', // Можно изменить на 'ua' для теста
  setLanguage(lang) {
    if (["en", "de", "ru", "ua", "hy"].includes(lang)) {
      this.currentLanguage = lang;
    }
  },
});
